import { Box, styled } from "@mui/material"
import { TableVariants } from "../interfaces"
import { BORDER_RADIUS } from "../configs"

type TableRowShadowProps = {
    colCount: number
    rowCap?: number
    active?: boolean
    variant?: TableVariants
    rowIndicatorColor?: string
    transparent?: boolean
}

function shouldForwardProp(prop: PropertyKey) {
    return !["colCount", "active", "rowCap", "variant", "rowIndicatorColor", "transparent"].includes(prop as string)
}

const TableRowShadowComponent = styled(Box, { shouldForwardProp })<TableRowShadowProps>(({ colCount, rowCap, active, variant, transparent }) => {
    return {
        zIndex: 0,
        gridColumnStart: 1,
        gridColumnEnd: `span ${colCount}`,
        height: variant === "small" ? 1 : 2,
        marginBottom: `${rowCap}px`,
        filter: "drop-shadow(0 0 2px rgba(0, 0, 0, 0.3))",
        borderRadius: `0 0 ${BORDER_RADIUS} ${BORDER_RADIUS}`,
        backgroundColor: active ? `white !important` : "inherit",
        borderBottom: `1px solid ${transparent ? "transparent" : "rgba(0,0,0,0.1)"}`,
    }
})

export function TableRowShadow(props: TableRowShadowProps) {
    return <TableRowShadowComponent className="Table-rowShadow" {...props} />
}
